import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        paddingTop: 0
    },
    userInitialInfoContainer: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    userInitialInfoAvatar: {
        flexDirection: "row",
        alignItems: "center"
    },
    userCompaniesTitleContainer: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    profilePhoto: {
        width: 100,
        height: 100
    },
    campaignImageWrapper: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    campaignImageRadius: {
        height: 200,
        width: "100%"
    },
    campaignTag: {
        position: "absolute"
    },
    campaignBottom: {
        position: "absolute"
    },
    companyLogo: {
        width: 50,
        height: 50
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    flex1: {
        flex: 1
    },
    lightboxContainer: {
        flex: 1,
        backgroundColor: "rgba(0,0,0,0.9)",
        justifyContent: "center",
        alignItems: "center"
    },
    lightboxCloseBtn: {
        position: "absolute",
        zIndex: 1
    },
    lightboxImage: {
        width: "100%",
        height: "80%"
    }
});
export default stylesheet;
